import React from 'react';
import { auth } from './FireBase';

function UserInfo() {
    const user = auth.currentUser; // 現在のユーザーを取得

    if (!user) {
        // ユーザーがいない場合、プレースホルダーを表示
        return <p>Not Login</p>;
    }
    const style = {
        color:'#ffffff'
    }
    
    
    return (
        <div
            style={{
            ...style
            }}
        >
            <img src={user.photoURL} alt="User Avatar" />
            <p>{user.displayName}</p>
        </div>
    );
}

export default UserInfo;
